import * as PIXI from 'pixi.js';
import type { TextWordMetrics } from './TextWordMetrics';
import { WordElementSprite } from './WordElementSprite';


/**
 * TextWord contains a list of WordElements and is held by a TextLine.
 * This basically holds a full word.
 */
export class TextWord extends PIXI.Container {
    classType = 'TextWord';

    #textWordMetrics: TextWordMetrics = null;

    constructor(textWordMetrics: TextWordMetrics) {
        super();
        this.#textWordMetrics = textWordMetrics;
    }

    /**
     * Indicates if the TextWord container contains text visible to the user (for example not
     * spaces or new lines)
     */
    get hasVisibleText(): boolean {
        const bounds = this.#textWordMetrics.getBounds();
        return bounds.width > 0;
    }

    get metrics(): TextWordMetrics {
        return this.#textWordMetrics;
    }

    get wordElementSprites(): WordElementSprite[] {
        return this.children.filter(child => child instanceof WordElementSprite) as WordElementSprite[];
    }
}
